import React, { useEffect, useState  } from 'react';
import SeoHelmet from "../components/SeoHelmet";
import ContactForm from "../components/ContactForm";

import slide1 from "../assets/img/product_bg.jpg";
import Icon1 from "../assets/img/icon1.png";
import Icon2 from "../assets/img/Shape.svg";
import ContactModal from "../components/ContactModal";
import CustomerSay from "../components/CustomerSay";

// Import all your industry images
import Inds1 from "../assets/img/industrial&manufacturing.jpg";
import Inds2 from "../assets/img/hospitality&resorts.jpg";
import Inds3 from "../assets/img/retail&brandspaces.jpg";
import Inds4 from "../assets/img/corporate&admin.jpg";
import Inds5 from "../assets/img/healthcareclinics&wellness.jpg";
import Inds6 from "../assets/img/educationalinstitutions.svg";
import Inds7 from "../assets/img/governmentpolice&defense.jpg";

import Furn1 from "../assets/img/furnish_1.svg";
import Furn2 from "../assets/img/furnish_2.jpg";
import Furn3 from "../assets/img/furnish_3.svg";
import Furn4 from "../assets/img/furnish_4.jpg";
import Furn5 from "../assets/img/furnish_5.svg";

import Mearch1 from "../assets/img/mearch_1.jpg";
import Mearch2 from "../assets/img/mearch_2.jpg";
import Mearch3 from "../assets/img/mearch_3.jpg";
import Mearch4 from "../assets/img/mearch_4.jpg";

import Get1 from "../assets/img/get_in_touch_bg.jpg";
import Get2 from "../assets/img/get-in-tuch.png";

import Studio from "../assets/img/commitment.jpg";

import User1 from "../assets/img/user_1.jpg";
import User2 from "../assets/img/user_2.jpg";
import User3 from "../assets/img/user_3.jpg";

const tabs = [
  { label: "Uniforms" },
  { label: "Furnishings" },
  { label: "Merchandise" },
];

const Aboutus = () => {
  const [activeTab, setActiveTab] = useState(0);

 
  
    const [activeVideo, setActiveVideo] = useState(null);
  
    const handleOpenModal = (videoSrc) => {
      setActiveVideo(videoSrc); // Set the active video source
    };
  
    const handleCloseModal = () => {
      setActiveVideo(null); // Clear the active video source
    };
  
    useEffect(() => {
  
      if (window.Swiper) {
  
   
        const custswiper = new window.Swiper(".customerslide", {
          loop: true,
          slidesPerView: 1,
          navigation: {
            nextEl: ".testi-button-next",
            prevEl: ".testi-button-prev",
          },
          pagination: {
            el: ".swiper-paginationnn",
            clickable: true,
          },
          breakpoints: {
            768: {
              slidesPerView: 3,
              spaceBetween: 30,
             slidesPerGroup: 3,
  
            },
            // You can add more breakpoints if needed
          },
  
        });
  
      }
  
  
  
  
    }, []);
  
    return (
    <>
      <SeoHelmet />
 <ContactModal />
      {/* Banner Section */}
      <section>
        <div className="swiper animeslide ">
          <div className="swiper-wrapper">
            <div
              className="swiper-slide animeslide-slide slide1  product_banner"
              style={{ backgroundImage: `url(${slide1})` }}
            >
              <div className="container">
                <div className="row">
                  <div className="col-sm-6 banner_content">
                    <div className="content-slide">
                      <div data-animate="bottom" className="animeslide-heading">
                        <h2>Purpose-Driven Products</h2>
                        <p>
                          From heavy industries to hospitality, healthcare,
                          retail, and<br></br> more — we design and deliver{" "}
                          <b>custom uniforms</b> that balance<br></br> functionality,
                          durability, and style.
                          <b>
                            Each piece is crafted to<br></br> inspire teams, strengthen
                            brand identity, and withstand the<br></br> demands of
                            everyday work.
                          </b>{" "}
                          Alongside, our expertise extends to<br></br> select
                          furnishings, creating cohesive solutions that reflect
                          your<br></br>brand’s essence across every touchpoint.
                        </p>
                      </div>
                      <div data-animate="bottom" className="animeslide-desc">
                        <a href="#" data-bs-toggle="modal" data-bs-target="#staticBackdrop">
                          <span>Let’s Get Started</span>
                          <img src={Icon1} alt="" />
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Tabs Section */}
      <section className="container my-16">
        {/* Tab Headers */}
        <div className="flex relative">
          {tabs.map((tab, index) => (
            <button
              key={tab.label}
              onClick={() => setActiveTab(index)}
              className={`hhhhh ${activeTab === index ? "activetabs" : ""}`}
            >
              {tab.label}
            </button>
          ))}
        </div>
        {/* Active Underline Indicator */}
        <div className="relative">
          <div className="absolute bottom-0 left-0 w-full border-b border-gray-300"></div>
          <div
            className="absolute bottom-0 h-[2px] bg-gradient-to-r from-blue-700 to-green-500 transition-all duration-300"
            style={{
              left: `${(100 / tabs.length) * activeTab}%`,
              width: `${100 / tabs.length}%`,
            }}
          ></div>
        </div>
      </section>
      {/* Tab Content */}

      {activeTab === 0 && (
        <section className="brands_section industries_we_dress proudct_tab">
          <div className="industries_we_dress_with_purpose proudct_tab_content">
            <div className="container">
              <div className="row">
                <div className="col-sm-5">
                  <div
                    className="inds_1"
                    style={{ backgroundImage: `url(${Inds1})` }}
                    onClick={() =>
                      window.open("/uniform-manufacturer/industrial", "_self")
                    }
                  >
                    <h3>Industrial & Manufacturing</h3>
                    <p>Built for Durability. Designed for Safety</p>
                  </div>
                  <div
                    className="inds_1 brmbr"
                    style={{ backgroundImage: `url(${Inds2})` }}
                     onClick={() =>
                      window.open("/uniform-manufacturer/hospitality-resorts", "_self")
                    }
                  >
                    <h3>Hospitality & Resorts</h3>
                    <p>Where Uniforms Reflect Warmth & Elegance</p>
                  </div>
                </div>
                <div className="col-sm-7">
                  <div className="row">
                    <div className="col-sm-6">
                      <div
                        className="inds_3"
                        style={{ backgroundImage: `url(${Inds3})` }}
                        onClick={() =>
                          window.open("/uniform-manufacturer/retail-brand-spaces", "_self")
                        }
                      >
                        <h3>Retail & Brand Spaces</h3>
                        <p>Retail-Ready Uniforms with Brand Impact</p>
                      </div>
                    </div>
                    <div className="col-sm-6">
                      <div
                        className="inds_3"
                        style={{ backgroundImage: `url(${Inds4})` }}
                        onClick={() => window.open("/uniform-manufacturer/corporate-admin", "_self")}
                      >
                        <h3>Aviation</h3>
                        <p>Polished Look for Everyday Impact</p>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-sm-12">
                      <div
                        className="inds_4"
                        style={{ backgroundImage: `url(${Inds5})` }}
                        onClick={() =>
                          window.open("/uniform-manufacturer/healthcare-clinics-wellness", "_self")
                        }
                      >
                        <h3>Healthcare, Clinics & Wellness</h3>
                        <p>Dependable Wear for Demanding Roles</p>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-sm-6">
                      <div
                        className="inds_3"
                        style={{ backgroundImage: `url(${Inds6})` }}
                        onClick={() =>
                          window.open("/uniform-manufacturer/educational-institutions", "_self")
                        }
                      >
                        <h3>Educational Institutions</h3>
                        <p>Smart Uniform for Bright Minds</p>
                      </div>
                    </div>
                    <div className="col-sm-6">
                      <div
                        className="inds_3"
                        style={{ backgroundImage: `url(${Inds7})` }}
                        onClick={() =>
                          window.open("/uniform-manufacturer/government-police-defense", "_self")
                        }
                      >
                        <h3>Government, Police & Defense</h3>
                        <p>Proudly Serving Those Who Serve</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      )}

      {activeTab === 1 && (
        <section className="brands_section industries_we_dress proudct_tab">
          <div className="industries_we_dress_with_purpose proudct_tab_content">
            <div className="container">
              <div className="row">
                <div className="col-sm-4">
                  <div
                    className="inds_1 brmbr"
                    style={{ backgroundImage: `url(${Furn1})` }}
                    onClick={() => window.open("/uniform-manufacturer/bed-linens", "_self")}
                  >
                    <h3>Bed Linens</h3>
                    <p>Soft, Durable, and Elegantly Tailored</p>
                  </div>
                </div>
                <div className="col-sm-4">
                  <div
                    className="inds_1 brmbr"
                    style={{ backgroundImage: `url(${Furn2})` }}
                    onClick={() => window.open("/uniform-manufacturer/pillows-cushions", "_self")}
                  >
                    <h3>pillows/cushions</h3>
                    <p>Plush Comfort with a Touch of Style</p>
                  </div>
                </div>
                <div className="col-sm-4">
                  <div
                    className="inds_1 brmbr"
                    style={{ backgroundImage: `url(${Furn3})` }}
                    onClick={() => window.open("/uniform-manufacturer/roller-blinds", "_self")}
                  >
                    <h3>roller blinds</h3>
                    <p>Sleek, Functional, and Light-Controlling</p>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-sm-6">
                  <div
                    className="inds_1 brmbr"
                    style={{ backgroundImage: `url(${Furn4})` }}
                    onClick={() => window.open("/uniform-manufacturer/curtains", "_self")}
                  >
                    <h3>curtains</h3>
                    <p>Draped in Elegance, Designed for Privacy</p>
                  </div>
                </div>
                <div className="col-sm-6">
                  <div
                    className="inds_1 brmbr"
                    style={{ backgroundImage: `url(${Furn5})` }}
                    onClick={() => window.open("/uniform-manufacturer/bathroom-furnishing", "_self")}
                  >
                    <h3>bathroom furnishing</h3>
                    <p>Thoughtful Details for a Luxurious Bathing Experience</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      )}

      {activeTab === 2 && (
        <section className="brands_section industries_we_dress proudct_tab">
          <div className="industries_we_dress_with_purpose proudct_tab_content">
            <div className="container">
              <div className="row">
                <div className="col-sm-6">
                  <div
                    className="inds_1 brmbr"
                    style={{ backgroundImage: `url(${Mearch1})` }}
                    onClick={() => window.open("/uniform-manufacturer/uniform-packaging", "_self")}
                  >
                    <h3>Uniform packaging</h3>
                    <p>Individually packed uniforms for each staff</p>
                  </div>
                </div>
                <div className="col-sm-6">
                  <div
                    className="inds_1 brmbr"
                    style={{ backgroundImage: `url(${Mearch2})` }}
                    onClick={() => window.open("/uniform-manufacturer/logo-embroidery", "_self")}
                  >
                    <h3>Logo embroidery </h3>
                    <p>Custom embroidered logos for brand identity</p>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-sm-6">
                  <div
                    className="inds_1 brmbr"
                    style={{ backgroundImage: `url(${Mearch3})` }}
                    onClick={() => window.open("/uniform-manufacturer/accessories", "_self")}
                  >
                    <h3>Accessories</h3>
                    <p>Ties, belts, badges, and name tags</p>
                  </div>
                </div>
                <div className="col-sm-6">
                  <div
                    className="inds_1 brmbr"
                    style={{ backgroundImage: `url(${Mearch4})` }}
                    onClick={() => window.open("/uniform-manufacturer/sachets", "_self")}
                  >
                    <h3>Sachets</h3>
                    <p>Tea and fragrance sachets for guests</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      )}

      <section
        className="get_in_touch_section product_get"
        style={{ backgroundImage: `url(${Get1})` }}
      >
        <div className="container">
          <div className="row get_in_touch">
            <div className="col-sm-5 get_in_touch_left">
              <div className="get_in_touch_lefts">
                <div className="brands_content get_content">
                  <h2>Get In Touch</h2>
                  <p>
                    Every great idea begins with a chat. Let’s talk about your
                    next project.
                  </p>
                </div>
                <img src={Get2} alt="" className="get_in_touch" />
              </div>
            </div>
            <div className="col-sm-6">
              <div className="get_in_touch_right">
                <ContactForm />
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="ambience_and_harmony_section">
        <div className="container">
          <div className="row about_the_studio about_product">
            <div className="col-sm-6">
              <div className="ambience_content">
                <div className="brands_content the_studio product_content">
                  <h2>Our Commitment to Every Stitch</h2>
                  <p>
                    We believe a uniform is more than just workwear—it’s the
                    everyday face of your brand. That’s why we put an unwavering
                    focus on design, material selection, and craftsmanship to
                    ensure each piece is comfortable, durable, and perfectly
                    aligned with your brand identity. From collaborative
                    prototyping to precise production, we stay committed to
                    delivering uniforms that reflect both functionality and
                    pride in every thread.
                  </p>
                  <div
                    data-animate="bottom"
                    className="animeslide-desc studio_btn"
                  >
                    <a href="#" data-bs-toggle="modal" data-bs-target="#staticBackdrop">
                      <span>Let’s Get Started</span>
                      <img src={Icon1} alt="" />
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-sm-5">
              <div className="ambience_imgs">
                <img src={Studio} alt="" className="studio" />
              </div>
            </div>
          </div>
        </div>
      </section>
      <CustomerSay />
    </>
  );
};

export default Aboutus;
